import React from "react";
import cx from "classnames";
import Wrapper from "./tabNavigator.styles";
import { useInitialTab } from "./useInitialTab";
import { useTabContext } from "../context";
import { AccessibleButton } from "../../button";

export const TabNavigator = ({ initialTab }) => {
  const { tabList, activeTabId, setActiveTabId } = useTabContext();
  useInitialTab(initialTab);

  return (
    <nav>
      <Wrapper>
        {tabList.map(({ tabTitle, tabId }) => (
          <AccessibleButton
            element="li"
            key={tabId}
            className={cx("tab-item", { active: activeTabId === tabId })}
            onClick={() => setActiveTabId(tabId)}
          >
            {tabTitle()}
          </AccessibleButton>
        ))}
      </Wrapper>
    </nav>
  );
};
